import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleDurationTypes = React.lazy(() => import('./index'));
const ArticleDurationTypeTable = React.lazy(() => import('./articleDurationTypeTable'));
const ArticleDurationType = React.lazy(() => import('./articleDurationType'));
const ArticleDurationTypeDetail = React.lazy(() => import('./articleDurationTypeDetail'));
const AddNewArticleDurationType = React.lazy(() => import('./addNewArticleDurationType'));
const EditArticleDurationType = React.lazy(() => import('./editArticleDurationType'));

export const useArticleDurationTypeRoutes = () => {

    return (
        <Route path="articleDurationTypes" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleDurationTypes /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleDurationTypeTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewArticleDurationType/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleDurationType/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleDurationTypeDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditArticleDurationType/></Suspense> } />
            </Route>
        </Route>
    )
}